export default "__VITE_ASSET__DF_GK8N0__"